import type { RefObject } from 'react';
import type { PhotoSection } from '../shared/photo';

export function ContributionButton({
  section,
  buttonRef,
  disabled,
  describedBy,
  onClick,
  className = '',
}: {
  section: PhotoSection;
  buttonRef: RefObject<HTMLButtonElement | null>;
  disabled: boolean;
  describedBy?: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      ref={buttonRef}
      type="button"
      className={`contribution-button ${className}`}
      disabled={disabled}
      aria-describedby={describedBy}
      onClick={onClick}
    >
      <span className="contribution-face" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none" focusable="false">
          {section === 'celebration' ? (
            <>
              <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 5a2 2 0 0 0-1.7 1L9 8H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4h-3l-1.3-2A2 2 0 0 0 20 5h-8Zm4 7a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
              />
              <circle cx="16" cy="18" r="3.8" fill="currentColor" />
              <circle cx="25.5" cy="12.5" r="1" className="contribution-icon-cutout" />
            </>
          ) : (
            <>
              <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 3a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h10.3A9 9 0 0 1 29 17.3V7a4 4 0 0 0-4-4H7Zm3.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM7 23l6-7 4 4 3-3 2 2a8.9 8.9 0 0 0-4.5 4H7Z"
              />
              <path d="M25 20v10m-5-5h10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
            </>
          )}
        </svg>
      </span>
      <span className="contribution-caption">
        {section === 'celebration' ? 'Add party photos' : 'Add memories'}
      </span>
    </button>
  );
}
